import { QueryClient, useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { createBrowserRouter } from 'react-router'
import { RouterProvider } from 'react-router/dom'

import { paths } from '@/config/paths'
import { ProtectedRoute } from '@/lib/auth'

import { default as AppRoot, ErrorBoundary as AppRootErrorBoundary } from './routes/app/root'

const convert = (queryClient: QueryClient) => (m: any) => {
  const { clientLoader, clientAction, default: Component, ...rest } = m
  return {
    ...rest,
    loader: clientLoader?.(queryClient),
    action: clientAction?.(queryClient),
    Component,
  }
}

export const createAppRouter = (queryClient: QueryClient) =>
  createBrowserRouter([
    {
      path: paths.home.path,
      lazy: () => import('./routes/landing').then(convert(queryClient)),
    },
    // {
    //   path: paths.auth.register.path,
    //   lazy: () => import('./routes/auth/register').then(convert(queryClient)),
    // },
    {
      path: paths.auth.login.path,
      lazy: () => import('./routes/auth/login').then(convert(queryClient)),
    },
    {
      path: paths.app.root.path,
      element: (
        <ProtectedRoute>
          <AppRoot />
        </ProtectedRoute>
      ),
      ErrorBoundary: AppRootErrorBoundary,
      children: [
        // {
        //   path: paths.app.discussions.path,
        //   lazy: () => import('./routes/app/discussions/discussions').then(convert(queryClient)),
        // },
        // {
        //   path: paths.app.discussion.path,
        //   lazy: () => import('./routes/app/discussions/discussion').then(convert(queryClient)),
        // },
        {
          path: paths.app.stations.path,
          lazy: () => import('./routes/app/stations/stations').then(convert(queryClient)),
        },
        // {
        //   path: paths.app.station.path,
        //   lazy: () => import('./routes/app/stations/station').then(convert(queryClient)),
        // },
        {
          path: paths.app.areas.path,
          lazy: () => import('./routes/app/areas/areas').then(convert(queryClient)),
        },
        {
          path: paths.app.area.path,
          lazy: () => import('./routes/app/areas/area').then(convert(queryClient)),
        },
        {
          path: paths.app.users.path,
          lazy: () => import('./routes/app/users/users').then(convert(queryClient)),
        },
        {
          path: paths.app.dashboard.path,
          lazy: () => import('./routes/app/dashboard').then(convert(queryClient)),
        },
      ],
    },
    {
      path: '*',
      lazy: () => import('./routes/not-found').then(convert(queryClient)),
    },
  ])

export const AppRouter = () => {
  const queryClient = useQueryClient()
  const router = useMemo(() => createAppRouter(queryClient), [queryClient])

  return <RouterProvider router={router} />
}
